import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { getSignalsFromGroupedSignals } from "app/pages/sales-intelligence/domain/signals/utils/signal-ids";
import {
    savedSearchFiltersQueryKeys,
    savedSearchMutationKeys,
} from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/query";
import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { NewSearchDto, SavedSearchDto } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/dto";
import { signalsUpsertedAction } from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

interface IUpdateSavedSearchMutationParams {
    searchId: string;
    dto: NewSearchDto;
}
export const useUpdateSavedSearchMutation = () => {
    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    return useMutation<SavedSearchDto, Error, IUpdateSavedSearchMutationParams>({
        mutationKey: savedSearchMutationKeys.update(),
        mutationFn: ({ searchId, dto }: IUpdateSavedSearchMutationParams): Promise<SavedSearchDto> => {
            return salesApiService.leadsSearch.savedSearches.updateSearchById(searchId, dto);
        },
        onSuccess: (data) => {
            const signals = getSignalsFromGroupedSignals(data.queryFilters.signalsFilters ?? {});

            if (signals.length > 0) {
                dispatch(signalsUpsertedAction(signals));
            }

            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.savedSearches("") });
            void queryClient.invalidateQueries({ queryKey: savedSearchFiltersQueryKeys.getById(data.searchId) });
        },
    });
};
